<template>
  <div :id="$attrs['id']" class="printerWrapper">
    <spinner-overlay v-if="loading" />
    <iframe id="printeriframe" ref="printeriframe" src="about:blank"></iframe>
  </div>
</template>

<script>

import { isNil } from 'lodash';
import printJS from 'print-js';
import SpinnerOverlay from './SpinnerOverlay';
import HotelmeisterMixin from '../../../mixins/HotelmeisterMixin';
import UpdateHotelSettingsMixin from '../../../mixins/UpdateHotelSettingsMixin';
import TimerMixin from '../../../mixins/TimerMixin';

export default {
  name: 'Printer',
  components: { SpinnerOverlay },

  mixins: [HotelmeisterMixin, UpdateHotelSettingsMixin, TimerMixin],

  data() {
    return {
      loading: false,
      timer: null,
    };
  },

  created: function () {
    this.$serviceBus.$off('printPDF');
    this.$serviceBus.$off('printHTML');

    this.$serviceBus.$on('printPDF', (url) => {
      this.printPDF(url);

      this.addUIBreadcrumb(
        'Initiate PDF printing',
        {
          url: url,
        },
      );
    });
    this.$serviceBus.$on('printHTML', (url) => {
      this.printHTML(url);

      this.addUIBreadcrumb(
        'Initiate HTML printing',
        {
          url: url,
        },
      );
    });
  },

  methods: {
    printPDF(url) {
      if (isNil(url)) {
        return;
      }
      printJS({
        printable: url,
        type: 'pdf',
        showModal: true,
        onLoadingStart: () => { this.startLoading(); },
        onLoadingEnd: () => { this.stopLoading(); },
        onError: (_) => {
          this.stopLoading(true);
          window.open(url, '_blank');
        },
        onIncompatibleBrowser: (_) => {
          this.stopLoading(true);
          window.open(url, '_blank');
        },
        onPdfOpen: () => { this.stopLoading(); },
        onPrintDialogClose: () => { this.stopLoading(); },
      });
    },
    printHTML(url) {
      this.axios.get(url)
        .then((response) => {
          if (!isNil(this.$refs.printeriframe)) {
            try {
              this.$refs.printeriframe.onload = () => { this.$refs.printeriframe.contentWindow.print(); };
              this.$refs.printeriframe.srcdoc = response.data;
            } finally {
              this.setTimeout(() => {
                this.$refs.printeriframe.onload = null;
                this.$refs.printeriframe.srcdoc = '';
              }, 2500);
            }
          } else {
            this.showErrorMessage();
            this.report('$refs.printeriframe is not initialized');
          }
        });
    },
    startLoading() {
      if (!isNil(this.timer)) this.clearTimeout(this.timer);
      this.loading = true;
      this.timer = this.setTimeout(() => {
        this.loading = false;
        this.showErrorMessage(this.$t('util.printer.errorDownloadingPDF'));
      }, 15000);
    },
    stopLoading(error = false) {
      if (!isNil(this.timer)) {
        this.clearTimeout(this.timer);
        this.timer = null;
      }
      this.loading = false;
      // disabled error message for now as this seems to mainly occur on mobile devices (without a printer attached)
      // if (error === true) this.showErrorMessage('Beim herunterladen des PDFs ist ein unerwarteter Fehler aufgetreten.');
    },
  },
};
</script>

<style lang="scss">
  @import '~styles/import';

  #printJS-Modal {
    opacity: 0;
    pointer-events: none;
  }

  .printerWrapper {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999999;
    pointer-events: none;
  }

  #printJS {
    opacity: 0;
    pointer-events: none;
    position: fixed!important; // required so we don't get a scroll bug - display: none; can't be used because it would not print
  }

  #printeriframe {
    opacity: 0;
    pointer-events: none;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    position: fixed!important; // required so we don't get a scroll bug - display: none; can't be used because it would not print
  }

</style>



// WEBPACK FOOTER //
// src/components/lib/util/Printer.vue